import React, { useContext } from 'react';
import { Button, Popconfirm, Space, Table, Tag } from 'antd';
import { ColumnsType } from 'antd/es/table';

import GlobalContactsContext from '@totem/components/administration/globalContacts/GlobalContactsContext';
import { GlobalContact } from '@totem/components/administration/globalContacts/types';
import IBDIcon from '@totem/styles/Icon';

const GlobalContactsTable = () => {
  const { contacts, loading, saving, openEditModal, deleteContact } =
    useContext(GlobalContactsContext);

  const columns: ColumnsType<GlobalContact> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: (value?: string) => value || '—',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      render: (value?: string) => value || '—',
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      key: 'phone',
      render: (value?: string) => value || '—',
    },
    {
      title: 'Labels',
      dataIndex: 'labels',
      key: 'labels',
      render: (labels: string[]) =>
        labels?.length
          ? labels.map((label) => <Tag key={label}>{label}</Tag>)
          : '—',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Button
            title={'Edit'}
            shape={'circle'}
            onClick={() => openEditModal(record)}
            icon={<IBDIcon name={'Edit'} />}
          />
          <Popconfirm
            title="Delete this contact?"
            okText="Yes"
            cancelText="No"
            placement="left"
            onConfirm={() => deleteContact(record.id)}
          >
            <Button
              title={'Delete'}
              shape={'circle'}
              danger
              icon={<IBDIcon name={'Delete'} />}
            />
          </Popconfirm>
        </Space>
      ),
      width: 120,
    },
  ];

  return (
    <Table<GlobalContact>
      rowKey="id"
      dataSource={contacts}
      columns={columns}
      loading={loading || saving}
      pagination={false}
    />
  );
};

export default GlobalContactsTable;
